var map = {
	"./colchoes/baby-d-18/0.webp": "ba63",
	"./colchoes/base-com-cabeceira/0.webp": "23b3",
	"./colchoes/berillo-d-45/0.webp": "4612",
	"./colchoes/bronze-d-23/0.webp": "ab11",
	"./colchoes/colchonete-d-20/0.webp": "7b53",
	"./colchoes/colchão-box-apolo-bonnel/0.webp": "a4a7",
	"./colchoes/colchão-box-máxximus/0.webp": "39d0",
	"./colchoes/colchão-ouro-d65/0.webp": "22a0",
	"./colchoes/conjunto-box-absolut/0.webp": "55d8",
	"./colchoes/conjunto-box-ametista/0.webp": "de68",
	"./colchoes/conjunto-box-bono/0.webp": "fea0",
	"./colchoes/conjunto-box-brilhante-d-28-e-bonnel-com-auxiliar/0.webp": "fdb3",
	"./colchoes/conjunto-box-brilhante-mola-com-auxiliar-mola/0.webp": "f537",
	"./colchoes/conjunto-box-centaurus/0.webp": "65c3",
	"./colchoes/conjunto-box-diamante/0.webp": "9533",
	"./colchoes/conjunto-box-donatello/0.webp": "d895",
	"./colchoes/conjunto-box-elegance/0.webp": "b187",
	"./colchoes/conjunto-box-essence/0.webp": "1c36",
	"./colchoes/conjunto-box-granada/0.webp": "15a2",
	"./colchoes/conjunto-box-imperial/0.webp": "a7fd",
	"./colchoes/conjunto-box-infinit/0.webp": "28b3",
	"./colchoes/conjunto-box-invictus/0.webp": "e3a6",
	"./colchoes/conjunto-box-macro-d28/0.webp": "8fcb",
	"./colchoes/conjunto-box-magnus/0.webp": "dc43",
	"./colchoes/conjunto-box-makro-bonnel-cabeceira/0.webp": "8be2",
	"./colchoes/conjunto-box-makro-bonnel/0.webp": "1483",
	"./colchoes/conjunto-box-makro-pocket-cabeceira/0.webp": "256f",
	"./colchoes/conjunto-box-malbec-d-45/0.webp": "0686",
	"./colchoes/conjunto-box-molejo-bonnel/0.webp": "55ad",
	"./colchoes/conjunto-box-new-top-d28/0.webp": "7531",
	"./colchoes/conjunto-box-personálity/0.webp": "d89a",
	"./colchoes/conjunto-box-prime/0.webp": "fdca",
	"./colchoes/conjunto-box-pujante-superlastic/0.webp": "70a8",
	"./colchoes/conjunto-box-revolution/0.webp": "644a",
	"./colchoes/conjunto-box-scalibu-pocket/0.webp": "3929",
	"./colchoes/conjunto-box-talismã/0.webp": "4d2b",
	"./colchoes/conjunto-box-turquia/0.webp": "e6a2",
	"./colchoes/conjunto-box-uni-pocket/0.webp": "7072",
	"./colchoes/conjunto-box-visco-elástica/0.webp": "67c5",
	"./colchoes/conjunto-box-vivence/0.webp": "4396",
	"./colchoes/conjunto-box-ômega/0.webp": "fe2a",
	"./colchoes/green-d-33/0.webp": "4934",
	"./colchoes/pérola-d-28/0.webp": "d9a2",
	"./colchoes/safira-d-20/0.webp": "7916",
	"./comodas-e-penteadeiras/cômoda-ester/0.webp": "a7d2",
	"./comodas-e-penteadeiras/cômoda-roupeiro-ariela/0.webp": "4500",
	"./comodas-e-penteadeiras/cômoda-zara/0.webp": "cb62",
	"./comodas-e-penteadeiras/mesa-de-cabeceira-jafé/0.webp": "56d4",
	"./comodas-e-penteadeiras/roupeiro-e-cômoda-vasti/0.webp": "e920",
	"./cozinhas/cozinha-dalila/0.webp": "ceb9",
	"./cozinhas/cozinha-eva/0.webp": "3808",
	"./cozinhas/cozinha-madalena/0.webp": "2c42",
	"./cozinhas/cozinha-noemi/0.webp": "f4aa",
	"./cozinhas/cozinha-thalita/0.webp": "620b",
	"./escrivaninhas/escrivaninha-rebeca/0.webp": "edb4",
	"./estofados/conjunto-te130/0.webp": "6f25",
	"./estofados/conjunto-te131/0.webp": "2423",
	"./estofados/conjunto-te154/0.webp": "aaff",
	"./estofados/conjunto-te183/0.webp": "8f7d",
	"./estofados/conjunto-te184/0.webp": "7d8f",
	"./estofados/conjunto-te187/0.webp": "a266",
	"./estofados/conjunto-te188/0.webp": "9421",
	"./estofados/conjunto-te191/0.webp": "af48",
	"./estofados/conjunto-te198/0.webp": "f498",
	"./estofados/conjunto-te207/0.webp": "87fb",
	"./estofados/conjunto-te210/0.webp": "195c",
	"./estofados/conjunto-te212/0.webp": "980c",
	"./estofados/conjunto-te213/0.webp": "a4d2",
	"./estofados/conjunto-te215/0.webp": "a5c1",
	"./estofados/conjunto-te216/0.webp": "63e3",
	"./estofados/conjunto-te220/0.webp": "ee49",
	"./estofados/conjunto-te225/0.webp": "be10",
	"./estofados/conjunto-te226/0.webp": "56f3",
	"./estofados/conjunto-te227/0.webp": "2c70",
	"./estofados/conjunto-te228/0.webp": "f56b",
	"./estofados/conjunto-te229/0.webp": "c4b0",
	"./estofados/conjunto-te232/0.webp": "a3b8",
	"./estofados/estofado-te197/0.webp": "728c",
	"./estofados/estofado-te211/0.webp": "25c1",
	"./roupeiros/mesa-de-cabeceira-jafe/0.webp": "15da",
	"./roupeiros/multiuso-naum/0.webp": "352c",
	"./roupeiros/roupeiro-abdon---4-portas/0.webp": "593a",
	"./roupeiros/roupeiro-abdon---6-portas/0.webp": "3851",
	"./roupeiros/roupeiro-abner/0.webp": "f21e",
	"./roupeiros/roupeiro-ageu---5-portas/0.webp": "892f",
	"./roupeiros/roupeiro-ageu---6-portas/0.webp": "0c24",
	"./roupeiros/roupeiro-arão/0.webp": "8fac",
	"./roupeiros/roupeiro-asafe/0.webp": "b99e",
	"./roupeiros/roupeiro-e-cômoda-vasti/0.webp": "6b63",
	"./roupeiros/roupeiro-elom/0.webp": "5518",
	"./roupeiros/roupeiro-jessé---4-portas/0.webp": "fac6",
	"./roupeiros/roupeiro-jessé---6-portas/0.webp": "83b3",
	"./roupeiros/roupeiro-jonas/0.webp": "9b68",
	"./roupeiros/roupeiro-josias/0.webp": "05e6",
	"./roupeiros/roupeiro-lucas/0.webp": "56e8",
	"./roupeiros/roupeiro-mateus---4-portas/0.webp": "d3b5",
	"./roupeiros/roupeiro-mateus---6-portas/0.webp": "c2c3",
	"./roupeiros/roupeiro-matias/0.webp": "d473",
	"./roupeiros/roupeiro-mu-200e/0.webp": "8384",
	"./roupeiros/roupeiro-noah/0.webp": "48ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08a0";